import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { DEVICE, SIDEBAR_WIDTH } from '@hero/constants';

const DashboardLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 100%;
  overflow: hidden;
`;

const DashboardLayoutContent = styled(motion.div)`
  display: flex;
  flex-direction: ${({ isDataDashboard }) => (isDataDashboard ? 'row' : 'column')};
  flex-grow: 1;
`;

const DashboardLayoutBody = styled.div`
  display: flex;
  flex-grow: 1;
  min-height: 100%;
  overflow: hidden;
  position: relative;

  ${({ isSidebarOpen, isSidebarDisabled }) => {
    if (isSidebarDisabled) {
      return css`
        ${DashboardLayoutContent} {
          max-width: 100%;
          transform: translateX(0);
        }
      `;
    }
    return css`
      ${DashboardLayoutContent} {
        max-width: calc(100% - ${isSidebarOpen ? SIDEBAR_WIDTH.open : SIDEBAR_WIDTH.closed});
        transform: translateX(${isSidebarOpen ? SIDEBAR_WIDTH.open : SIDEBAR_WIDTH.closed});

        ${DEVICE.mobile.max} {
          max-width: 100%;
          transform: translateX(0) !important;
        }
      }
    `;
  }}

  ${DEVICE.mobile.max} {
    flex-direction: column;
    overflow: unset;

    ${DashboardLayoutContent} {
      max-width: 100%;
      transform: none;
    }
  }
`;

export { DashboardLayout, DashboardLayoutBody, DashboardLayoutContent };
